import { createPortal } from 'react-dom';
import { CloudUpload } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useThemeContext } from '@utils/hooks/use-theme-context.ts';

/** Floating "Drop to upload" pill shown while files are dragged over the page. */
export function DropToUploadHint() {
  const { t } = useTranslation();
  const { getColour } = useThemeContext();
  return createPortal(
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[9998] pointer-events-none">
      <div
        className="flex items-center gap-3 rounded-full px-5 py-3 border border-hairline shadow-pop"
        style={{
          backgroundColor: getColour('secondLayer'),
          borderColor: getColour('hairline')
        }}
      >
        <CloudUpload size={24} style={{ color: getColour('activeText') }} />
        <span
          className="text-sm font-semibold"
          style={{ color: getColour('normalText') }}
        >
          {t('drop-to-upload')}
        </span>
      </div>
    </div>,
    document.body
  );
}
